// import { DialogComponent } from '@theme/dialog';
// import { CartAddEvent } from '@theme/events';

// /**
//  * A custom element that manages a cart drawer.
//  *
//  * @extends {DialogComponent}
//  */
// class CartDrawerComponent extends DialogComponent {
//   connectedCallback() {
//     super.connectedCallback();
//     document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();
//     document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
//   }

//   #handleCartAdd = () => {
//     if (this.hasAttribute('auto-open')) {
//       this.showDialog();
//     }
//   };

//   open() {
//     this.showDialog();

//     /**
//      * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
//      */
//     customElements.whenDefined('shopify-payment-terms').then(() => {
//       const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
//       const cta = installmentsContent?.querySelector('#shopify-installments-cta');
//       cta?.addEventListener('click', this.closeDialog, { once: true });
//     });
//   }

//   close() {
//     this.closeDialog();
//   }
// }

// if (!customElements.get('cart-drawer-component')) {
//   customElements.define('cart-drawer-component', CartDrawerComponent);
// }

import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };


open() {
  this.showDialog();

  // requestAnimationFrame(() => {
  //   const checkoutBtn = this.querySelector('.checkout_new');
  //   if (checkoutBtn) {
  //      console.log(' ID:', checkoutBtn.id || '(no id)', ' Class:', checkoutBtn.className || '(no class)');
  //     checkoutBtn.addEventListener('click', () => {
  //       console.log('Checkout button clicked!');
  //       const dialog = this.querySelector('.cart-drawer__dialog');
  //       dialog?.classList.add('active-new');
  //     });
  //   } else {
  //     console.log('Checkout button not found!');
  //   }
  // });
}




  // open() {
  //   this.showDialog();

  //   console.log('Drawer Content:', this.innerHTML);

  //   const checkoutBtn = this.querySelector('.checkout_new');
  //   const dialog = this.querySelector('.cart-drawer__dialog');
  //   if (checkoutBtn) {
  //     console.log('Checkout Button Found!');
  //     console.log(' ID:', checkoutBtn.id || '(no id)', ' Class:', checkoutBtn.className || '(no class)');
  //     checkoutBtn.addEventListener('click', () => {
  //       console.log('Checkout button clicked!');
  //       dialog.classList.add('active-new')
  //     });
  //     } else {
  //       console.log('Checkout button not found inside drawer!');
  //     }

  //   // 🛒 Shopify installments CTA handler
  //   customElements.whenDefined('shopify-payment-terms').then(() => {
  //     const installmentsContent = document
  //       .querySelector('shopify-payment-terms')
  //       ?.shadowRoot;
  //     const cta = installmentsContent?.querySelector(
  //       '#shopify-installments-cta'
  //     );
  //     cta?.addEventListener('click', this.closeDialog, { once: true });
  //   });
  // }

  close() {
    this.closeDialog();
  }
}

// ✅ Register the custom element if not already defined
if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
